import { recentPayments, formatMoney, type RecentPayment } from "@/mocks/managerWorkspace";

export default function PaymentsWidget() {
  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-bank-card-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Последние оплаты от клиентов</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D2D2D]">{recentPayments.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ оплаты / Счет</th>
              <th className="text-left px-2 py-1 font-medium">Сумма</th>
              <th className="text-left px-2 py-1 font-medium">Дата оплаты</th>
            </tr>
          </thead>
          <tbody>
            {recentPayments.map((p: RecentPayment, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{p.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{p.document}</td>
                <td className="px-2 py-1.5 text-[#2D6A4F] font-medium">{formatMoney(p.amount)}</td>
                <td className="px-2 py-1.5 text-[#666666]">{p.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все оплаты
        </button>
      </div>
    </div>
  );
}